var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "15px",
    viewBox: "0 0 20 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1298.000000, -82.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1296.000000, 77.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0897813,4.99892741 C12.1097104,4.99897849 12.1327396,4.99904659 12.158721,4.99913739 L12.4682765,5.00072073 C13.1461264,5.00516999 14.4663182,5.01978897 15.8238512,5.06782276 L16.3334948,5.08744715 C17.7757486,5.14774476 19.1747835,5.24904475 19.8049242,5.41922873 C20.6685606,5.65786509 21.3503788,6.33968328 21.5776515,7.20331964 C21.9420455,8.56241055 21.9906313,11.2018045 21.9971094,11.8814813 L21.9979815,12.0020671 C21.9981061,12.0296833 21.9981061,12.0442287 21.9981061,12.0442287 L21.9980909,12.0549535 C21.9980758,12.0620419 21.9980455,12.0725823 21.9979848,12.0863903 L21.9971364,12.2069762 C21.9908333,12.886653 21.9435606,15.5260469 21.5890152,16.8851378 C21.3503788,17.7601378 20.6799242,18.441956 19.8162879,18.6692287 C18.3974567,19.04964 13.1461168,19.0858696 12.1587308,19.0893201 L11.8374912,19.0893201 C10.8501984,19.0858696 5.59983766,19.04964 4.19128788,18.6692287 C3.32765152,18.4305924 2.64583333,17.7487742 2.41856061,16.8851378 C2.04015152,15.4737742 2.00231061,12.6817287 1.99852652,12.1374333 L1.99851515,11.9510242 C2.00219697,11.4067287 2.03901515,8.61468328 2.40719697,7.20331964 C2.64583333,6.32831964 3.31628788,5.64650146 4.17992424,5.41922873 C4.8146645,5.24904475 6.21643733,5.14774476 7.66032071,5.08744715 L8.17049473,5.06782276 C9.529326,5.01978897 10.8499128,5.00516999 11.527883,5.00072073 L11.8374813,4.99913739 C11.8634652,4.99904659 11.8864962,4.99897849 11.9064267,4.99892741 Z M9.95265152,9.066956 L9.95265152,15.0215015 L15.1799242,12.0442287 L9.95265152,9.066956 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.55d65cbbf1573ae9e23992cb0a9e72c6.svg";
export { ForwardRef as ReactComponent };